import { EventDisplayDataRSVPOption } from "../../../../../../../../common/sesh_types";
import { InlineEmoji } from "../../../inline_emoji";

export function ConciseRSVPList(props: {
	preset: EventDisplayDataRSVPOption[];
}) {
	const { preset } = props;
	const columns: JSX.Element[] = [];
	let index = 0;
	for (let option of preset) {
		const emoji = <InlineEmoji option={option} />;
		columns.push(
			<div
				key={index}
				className="column is-one-third-tablet is-one-third-mobile column-in-table-cell has-text-centered-tablet"
			>
				{emoji} <span>{option.rsvp_count}</span>
			</div>
		);
		index++;
	}
	return <div className="columns is-multiline is-mobile">{columns}</div>;
}
